import {
  ButtonWrapper,
  Button,
  ButtonContent,
  ScanLine,
  SplashLayer,
  Droplet,
} from "./ExplosionButton.styles";

// Each droplet flies along an angle/distance from button center.
// Mixed sizes + slight stagger keeps the splash from feeling robotic.
const DROPLETS = [
  { angle: -100, distance: 110, size: 24, rot: 320, delay: 0, duration: 760 },
  { angle: -55, distance: 95, size: 18, rot: -280, delay: 30, duration: 720 },
  { angle: -10, distance: 120, size: 22, rot: 360, delay: 60, duration: 780 },
  { angle: 30, distance: 90, size: 16, rot: -300, delay: 80, duration: 700 },
  { angle: 75, distance: 85, size: 20, rot: 280, delay: 40, duration: 740 },
  { angle: 130, distance: 100, size: 19, rot: -340, delay: 50, duration: 760 },
  { angle: 175, distance: 115, size: 23, rot: 320, delay: 20, duration: 780 },
  { angle: -135, distance: 92, size: 17, rot: -260, delay: 70, duration: 720 },
];

const DROPLET_EMOJI = "💦";

const buildDropletStyle = ({ angle, distance, rot }) => {
  const rad = (angle * Math.PI) / 180;
  const dx = Math.cos(rad) * distance;
  const dy = Math.sin(rad) * distance;
  return {
    "--dx": `${dx.toFixed(1)}px`,
    "--dy": `${dy.toFixed(1)}px`,
    "--rot": `${rot}deg`,
  };
};

const ExplosionButton = ({
  children,
  isLoading = false,
  isExploding = false,
  disabled = false,
  onClick,
  style,
  buttonStyle,
  small,
  white = false,
  ...props
}) => {
  return (
    <ButtonWrapper onClick={onClick} style={style}>
      <Button
        disabled={disabled || isLoading}
        $isLoading={isLoading}
        $isExploding={isExploding}
        $small={small}
        $white={white}
        {...props}
        style={buttonStyle}
      >
        {isLoading && <ScanLine />}
        <ButtonContent $isExploding={isExploding}>{children}</ButtonContent>
      </Button>
      {isExploding && (
        <SplashLayer>
          {DROPLETS.map((d, i) => (
            <Droplet
              key={i}
              $size={d.size}
              $delay={d.delay}
              $duration={d.duration}
              style={buildDropletStyle(d)}
            >
              {DROPLET_EMOJI}
            </Droplet>
          ))}
        </SplashLayer>
      )}
    </ButtonWrapper>
  );
};

export default ExplosionButton;
